import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReprojectionCharts from '../ReprojectionCharts';
import BelowGraphNotification from './templates/BelowGraphNotification';
import ReprojectionTableDataFormatter from '../ReprojectionTableDataFormatter';
import ChartLegendsCheckbox from '../../charts/ChartLegendsCheckbox';
import {
  ChartTitle,
  GraphInfoSubHeaderDiv,
  InfoMessageSpan
} from '../reprojectionPageStyle';
import { FutureValueTabSubHeader } from '../templates';
import { trackEvents } from '../../utils/tealiumUtils';
import { getChartCheckboxInfo } from '../../utils/reprojectionsUtils';

/**
 * @param {Object} props
 * @description : contains sectionFieldConfig which can be iterated to render field component inside this template
 *  sectionFieldConfig[0] : array of fields object for chart
    sectionFieldConfig[1] : array of table header object for table
    sectionFieldConfig[2] : array of fields object of table main subsection
 */

const FutureValueSurrender = (props, context) => {
  const {
    productCategory,
    sectionFieldConfig,
    tableSectionAPIFieldParentKey,
    reprojectionsDetails,
    dependentFieldConfig,
    policyCurrencyFormat,
    reprojectionGenericConfig,
    sectionNotificationConfig,
    sectionToRender,
    reprojectionChartConfig: { surrenderValueChart, chartFields },
    customerAge,
    setCustomerAge,
    setCustomerMinPayAge,
    customerMinPayAge,
    toggleIncludeNonGuaranteedPayout,
    tabValues: {
      cashSurrender: { includeNonGuaranteedPayout }
    },
    selectedFutureBenefitsTab,
    policyPhaseFlag,
    reprojectionTealiumHandlers
  } = props;

  const {
    intl: { formatMessage }
  } = context;

  const { captureCheckBoxEvents } = reprojectionTealiumHandlers;
  const {
    chartIncludeNGCheckbox: { show: showCheckboxAsPerConfiguration }
  } = getChartCheckboxInfo(chartFields, sectionToRender);
  const [isDisplayCheckBox, displayChkBoxSetter] = useState(
    showCheckboxAsPerConfiguration
  );

  const {
    reprojectionDetails: { surrenderDetails }
  } = reprojectionsDetails;
  return (
    <>
      <ChartTitle>{formatMessage({ id: 'cashSurrenderLabel' })}</ChartTitle>
      {Object.keys(surrenderDetails).length > 1 && (
        <GraphInfoSubHeaderDiv>
          <InfoMessageSpan>
            {formatMessage({ id: 'graphInfoSubHeaderLabel' })}
          </InfoMessageSpan>
        </GraphInfoSubHeaderDiv>
      )}
      <FutureValueTabSubHeader
        reprojectionsDetails={reprojectionsDetails}
        selectedFutureBenefitsTab={selectedFutureBenefitsTab}
        id="surrenderValueChart"
        selectedTabName="SurrenderValue"
      />
      {isDisplayCheckBox && (
        <ChartLegendsCheckbox
          includeNonGuranteedPayout={includeNonGuaranteedPayout}
          onCheckboxChange={() =>
            captureCheckBoxEvents(
              toggleIncludeNonGuaranteedPayout,
              'cashSurrender',
              includeNonGuaranteedPayout,
              'non-guaranteed surrender value',
              trackEvents
            )
          }
          label="legendCheckboxIncludeNonGuranteedCashSurrender"
          checkboxId="future-value-surrender"
        />
      )}
      <ReprojectionCharts
        productCategory={productCategory}
        reprojectionsData={reprojectionsDetails}
        chartConfig={surrenderValueChart}
        sectionToRender={sectionToRender}
        showCheckboxAsPerConfiguration={showCheckboxAsPerConfiguration}
        isNonGuaranteedChecked={includeNonGuaranteedPayout}
        tooltipContent="tooltipTotalAmountAllocate"
        policyCurrencyFormat={policyCurrencyFormat}
        id="surrenderValueChart"
        setValue={setCustomerAge}
        value={customerAge}
        customerMinPayAge={customerMinPayAge}
        setCustomerMinPayAge={setCustomerMinPayAge}
        displayChkBoxSetter={displayChkBoxSetter}
        selectedTabName="SurrenderValue"
      />
      <BelowGraphNotification
        selectedTabName="SurrenderValue"
        reprojectionsDetails={reprojectionsDetails}
        sectionNotificationConfig={sectionNotificationConfig}
      />
      <ReprojectionTableDataFormatter
        tableSectionFieldConfig={sectionFieldConfig && sectionFieldConfig[2]}
        apiFieldParentKey={tableSectionAPIFieldParentKey}
        reprojectionsDetails={reprojectionsDetails}
        dependentFieldConfig={dependentFieldConfig}
        policyCurrencyFormat={policyCurrencyFormat}
        reprojectionGenericConfig={reprojectionGenericConfig}
        selectedFutureBenefitsTab={selectedFutureBenefitsTab}
        tableHeaderText="surrenderValueTableHeader"
        selectedTabName="SurrenderValue"
        policyPhaseFlag={policyPhaseFlag}
      />
    </>
  );
};

FutureValueSurrender.propTypes = {
  productCategory: PropTypes.string.isRequired,
  sectionFieldConfig: PropTypes.array.isRequired,
  tableSectionAPIFieldParentKey: PropTypes.string.isRequired,
  policyCurrencyFormat: PropTypes.string.isRequired,
  reprojectionsDetails: PropTypes.object.isRequired,
  dependentFieldConfig: PropTypes.object.isRequired,
  reprojectionGenericConfig: PropTypes.object.isRequired,
  sectionNotificationConfig: PropTypes.object.isRequired,
  sectionToRender: PropTypes.string.isRequired,
  reprojectionChartConfig: PropTypes.object.isRequired,
  customerAge: PropTypes.number.isRequired,
  setCustomerAge: PropTypes.func.isRequired,
  setCustomerMinPayAge: PropTypes.func.isRequired,
  customerMinPayAge: PropTypes.number.isRequired,
  toggleIncludeNonGuaranteedPayout: PropTypes.func.isRequired,
  tabValues: PropTypes.object.isRequired,
  selectedFutureBenefitsTab: PropTypes.string.isRequired,
  policyPhaseFlag: PropTypes.bool.isRequired,
  reprojectionTealiumHandlers: PropTypes.object.isRequired
};

FutureValueSurrender.contextTypes = {
  intl: PropTypes.object.isRequired
};
export default FutureValueSurrender;
